/* eslint-disable */

import { Popover, Switch } from "antd";
import moment from "moment";
import { PiDotsThreeOutlineVerticalBold } from "react-icons/pi";

export const columnsData = (
  { handleChangeStatus, handleEdit },
  pageMenu,
  userFilter
) => {
  return [
    {
      title: "Tên đại lý",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onClick={() => handleEdit(1, record)}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Mã đại lý",
      dataIndex: "branch_code",
      key: "branch_code",
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)", fontWeight: "bold" }}>
            {text}
          </div>
        );
      },
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)", fontWeight: "bold" }}>
            {text}
          </div>
        );
      },
    },
    {
      title: "Nhân viên quản lý",
      dataIndex: "user",
      key: "user",
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)", fontWeight: "bold" }}>
            {record?.user &&
              userFilter.find((x) => x.value === record?.user)?.label}
          </div>
        );
      },
    },
    {
      title: "Người tạo",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        return (
          <>
            <div>
              {record?.created_by_user_info &&
                record?.created_by_user_info?.name}
            </div>
            <div>
              {record?.created_at &&
                moment(record?.created_at).format("YYYY-MM-DD")}
            </div>
          </>
        );
      },
    },
    {
      title: "Lần cập nhật cuối",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        return (
          <>
            <div>
              {record?.updated_by_user_info &&
                record?.updated_by_user_info?.name}
            </div>
            <div>
              {record?.updated_at &&
                moment(record?.updated_at).format("YYYY-MM-DD")}
            </div>
          </>
        );
      },
    },
    {
      title: "Trạng thái hoạt động",
      dataIndex: "status",
      key: "status ",
      render: (text, record, index) => {
        return (
          <Switch
            checked={text === "ACTIVE" ? true : false}
            disabled={!pageMenu.update}
            onChange={(e) => pageMenu.update && handleChangeStatus(e, record)}
          />
        );
      },
    },
  ];
};
